import React from 'react';

const shimmerDelay = (ms) => ({'--shimmer-delay': `${ms}ms`});

function MessageBubbleSkeleton({align = 'start', width = '55%', delay = 0}) {
    return (
        <div
            className={`d-flex mb-3 skeleton-item ${align === 'end' ? 'justify-content-end' : 'justify-content-start'}`}
            style={{animationDelay: `${delay}ms`}}
        >
            <span
                className="skeleton-block"
                style={{
                    height: 36,
                    width,
                    maxWidth: '75%',
                    borderRadius: align === 'end' ? '1rem 1rem 0.25rem 1rem' : '1rem 1rem 1rem 0.25rem',
                    ...shimmerDelay(delay + 40),
                }}
            />
        </div>
    );
}

function ConversationSkeleton() {
    return (
        <div
            className="sms-skeleton card shadow-sm border-0 d-flex flex-column"
            style={{height: 'calc(100vh - 200px)'}}
        >
            <div className="card-header bg-white border-bottom py-3 px-3 skeleton-item">
                <div className="d-flex align-items-center">
                    <span
                        className="skeleton-block skeleton-circle me-3"
                        style={{width: 40, height: 40, ...shimmerDelay(0)}}
                    />
                    <div className="flex-grow-1">
                        <span
                            className="skeleton-block mb-2 d-block"
                            style={{height: 14, width: '35%', ...shimmerDelay(40)}}
                        />
                        <span
                            className="skeleton-block d-block"
                            style={{height: 12, width: '25%', ...shimmerDelay(60)}}
                        />
                    </div>
                    <span
                        className="skeleton-block"
                        style={{height: 32, width: 32, ...shimmerDelay(80)}}
                    />
                </div>
            </div>

            <div className="card-body flex-grow-1 px-3 py-3" style={{overflowY: 'auto'}}>
                <div className="text-center mb-3 skeleton-item" style={{animationDelay: '100ms'}}>
                    <span
                        className="skeleton-block d-inline-block"
                        style={{height: 12, width: 80, ...shimmerDelay(100)}}
                    />
                </div>
                <MessageBubbleSkeleton align="start" width="62%" delay={120} />
                <MessageBubbleSkeleton align="end" width="48%" delay={180} />
                <MessageBubbleSkeleton align="start" width="70%" delay={240} />
                <MessageBubbleSkeleton align="end" width="40%" delay={300} />
                <MessageBubbleSkeleton align="start" width="52%" delay={360} />
            </div>

            <div className="card-footer bg-white border-top p-3 skeleton-item" style={{animationDelay: '400ms'}}>
                <span
                    className="skeleton-block d-block"
                    style={{height: 42, width: '100%', borderRadius: '0.5rem', ...shimmerDelay(420)}}
                />
            </div>
        </div>
    );
}

export default ConversationSkeleton;
